import type { CsspSearchCacheContext } from "./csspSearchCache";
import { resolveCsspCity } from "./csspCity";
import type { City } from "@/types/common";

export const createCsspSearchCacheContext = (
  city: string,
  isLoggedIn: boolean,
  user: unknown,
  cities: City[] = [],
  sessionGeneration = 0
): CsspSearchCacheContext => {
  // The backend does not currently expose a standalone price-condition id.
  // Keeping the complete session user payload in the fingerprint makes a
  // future price field participate automatically, without persisting it.
  const userFingerprint = isLoggedIn
    ? JSON.stringify(user ?? {})
    : "guest";
  const sessionKey = `${isLoggedIn ? "authenticated" : "guest"}:${sessionGeneration}`;

  const resolvedCity = resolveCsspCity(city, cities);
  return { city, cityId: resolvedCity?.id, cityCode: resolvedCity?.code, userFingerprint, sessionKey };
};
